export default __webpack_public_path__ + "static/media/coinbase.5509d828.jpg";